import { createFileRoute } from '@tanstack/react-router'

import { August2025PromoRoute } from '@/pages/promotion/route-entries/august-2025'
import { defaultPromoSearch, promoSearchSchema } from '@/pages/promotion/search-schemas'

export const Route = createFileRoute('/_layout/promotion/august-2025/')({
  component: August2025PromoRoute,
  validateSearch: (search) => promoSearchSchema.catch(defaultPromoSearch).parse(search),
  loaderDeps: ({ search }) => {
    return {
      search,
    }
  },
})
